import React, { useMemo } from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    contentSubtitle: {
      color: '#999999',
      fontSize: '14px',
      lineHeight: '20px',
      marginBottom: '20px',
    },
    contentTitle: {
      color: '#172B4D',
      fontSize: '36px',
      fontWeight: 'bold',
      lineHeight: '42px',
      marginBottom: '10px',
    },
    fontSuccess: {
      color: '#388E3C !important',
    },
    link: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      fontSize: '15px',
      fontWeight: '600',
      whiteSpace: 'nowrap',
    },
    planContainer: {
      background: '#F5F5F5',
      borderRadius: '5px',
      padding: '14px 12px',
    },
    planDetail: {
      color: '#172B4D',
      fontSize: '16px',
      lineHeight: '23px',
    },
    planTitle: {
      color: '#999999',
      fontSize: '12px',
      fontWeight: '600',
      lineHeight: '14px',
      marginBottom: '5px',
    },
    upgradeNote: {
      color: '#999999',
      fontSize: '12px',
      fontWeight: 'normal',
      lineHeight: '52px',
    },
  };
});
export default ({ onBuyVideoReport, availableReport, userDetail, isMobileView }) => {
  const classes = useStyles();

  const canRequestBeforePay = useMemo(() => {
    return userDetail?.workspace?.canRequestBeforePay;
  }, [userDetail]);

  const renderCredits = () => {
    if (canRequestBeforePay) return null;
    return (
      <>
        {/* Plan */}
        <Grid container>
          <Grid item xs={6} md={12} lg={9} xl={8} style={{ paddingRight: '5px' }}>
            <div className={classes.planContainer}>
              <Typography className={classes.planTitle}>Video Report Credits</Typography>
              <Typography className={classes.planDetail}>{availableReport?.type ? '1' : '0'}</Typography>
            </div>
          </Grid>
        </Grid>

        {!availableReport && (
          <Typography className={classes.upgradeNote} style={{ lineHeight: '16px' }}>
            Ready to get your personal, in-depth, visual explanation of your MRI or CT scan results?{' '}
            <span aria-hidden="true" className={`${classes.link} patient-dashboard-planinfo-button-buynow${isMobileView ? '-mobile' : ''}`} onClick={onBuyVideoReport}>
              Buy now
            </span>
          </Typography>
        )}
      </>
    );
  };

  return (
    <div className="text-left">
      <Typography variant="h2" className={classes.contentTitle}>
        {userDetail?.name || ''}
      </Typography>
      <Typography className={classes.contentSubtitle}>{userDetail?.email || '-'}</Typography>

      {renderCredits()}
    </div>
  );
};
